<template>
  <ul id="hoverComponentsForIndex">
    <li class="hang">
      <h4>航系列介绍</h4>
      <p>
        亿车三大“航”系列城市级静态交通运营管理产品与解决方案，精准适配不同体量客户群体需求，轻松应对各类前端技术，全面覆盖路内外停车场景。
      </p>
    </li>
    <router-link v-for="item in list" :key="item.name" :to="{path:item.path}">
      <li>
        <h4 class="cur">{{item.name}}</h4>
        <div>
          <img :src="item.img">
          <span>{{item.content}}</span>
        </div>
      </li>
    </router-link>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          name: '领航版',
          path: '/Solve/Pilotage',
          content: '城市静态交通成熟阶段',
          img: require('./images/u134.png'),
        },
        {
          name: '巡航版',
          path: '/Solve/cruise',
          content: '城市静态交通稳定阶段',
          img: require('./images/u137.png'),
        },
        {
          name: '启航版',
          path: '/Solve/Setsail',
          content: '城市静态交通初始阶段',
          img: require('./images/u140.png'),
        },
      ],
    };
  },
  methods: {},
};
</script>

<style lang="scss">
@import '../variable.scss';
#hoverComponentsForIndex {
  display: flex;
  display: -ms-flexbox;
  color: #000;
  padding: 40px 0;
  .hang {
    margin-right: 48px;
  }
  li {
    font-size: 14px;
    line-height: 14px;
    margin-right: 24px;
    display: inline-block;
    cursor: pointer;
    &:first-child {
      cursor: auto;
    }
    &:last-child {
      padding-right: 0;
    }
    h4 {
      margin-bottom: 25px;
      color: #0f2347;
    }
    p {
      width: 220px;
      line-height: 1.6;
      font-size: 14px;
      color: #000000;
      opacity: 0.88;
    }
    div {
      position: relative;
      img {
        width: 272px;
        height: 152px;
        cursor: pointer;
      }
      span {
        color: #ffffff;
        position: absolute;
        left: 20px;
        bottom: 20px;
      }
    }
  }
  a {
    color: #000000;
    text-decoration: none;
  }
  span {
    cursor: pointer;
  }
  span:hover {
    font-weight: bold;
  }
  .cur {
    cursor: pointer;
    color: #0f2347;
  }
}
</style>
